export default __webpack_public_path__ + "static/media/CNo.33-0.9bbb87c2.jpg";